export default __webpack_public_path__ + "src/assets/icn-announcement.76f874f8eb583ae5e44a3e6466af22ca.svg";